import lifestyle from './module/lifestyle';
import comment from './module/comment';
import user from './module/user';
import common from './module/common';
import house from './module/house';
import home from './module/home';
import used from './module/used';

// 导出接口
export default {
    lifestyle,
    comment,
    user,
    common,
    house,
    home,
    used,
}